import React, { useContext } from 'react';
import { Context } from '../../../context/Context';
import { useI18n } from '../../../i18n';
import { StickyButtonsContainer, StyledStickyButtons } from '../SubPageNavigationStyles';
import { CtaPrimary } from './CallToAction';

const StickyButtons: React.FC = () => {
  const {
    hasCta,
    renderPrimaryButton,
    content: { cta },
    showSubmenu,
  } = useContext(Context);
  const ariaLabel = useI18n('ariaDirectNavigation');

  if (!hasCta || showSubmenu || !renderPrimaryButton) {
    return null;
  }

  return (
    <StyledStickyButtons>
      <StickyButtonsContainer role="group" aria-label={ariaLabel}>
        <CtaPrimary {...cta[0]} />
      </StickyButtonsContainer>
    </StyledStickyButtons>
  );
};

export default StickyButtons;
